import React from 'react';
import Loading from './Loading';
import './PageLoading.css';

function PageLoading() {
  return (
    <div className="sbd-page-loading">
      <Loading />
    </div>
  );
}

export default PageLoading;
